import theme from "@monorepo/styles/theme";
import { Box, styled } from "@mui/material";

import { CardSizesEnum } from "./Card";

interface IStyledCardProps {
  size: CardSizesEnum;
  disabled?: boolean;
  icon: boolean;
  iconPosition: "left" | "right";
  active: boolean;
  iconUsesStroke?: boolean;
  unclickable?: boolean;
}

export const StyledCard = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "size" &&
    prop !== "icon" &&
    prop !== "active" &&
    prop !== "disabled" &&
    prop !== "iconUsesStroke" &&
    prop !== "iconPosition",
})<IStyledCardProps>(({ size, active, icon, disabled, iconUsesStroke, unclickable, iconPosition }) => ({
  display: "grid",
  alignItems: "center",
  backgroundColor: active ? theme.palette.card.dark : theme.palette.card.main,
  color: active ? theme.palette.card.contrastText : theme.palette.text.disabled,
  fill: iconUsesStroke ? "none" : "initial",
  stroke: iconUsesStroke ? (active ? theme.palette.card.main : theme.palette.primary.main) : "none",
  padding:
    size === CardSizesEnum.SMALL ? "12px 18px" : size === CardSizesEnum.BIG ? theme.spacing(4) : theme.spacing(3, 4),
  borderRadius: "3px",
  cursor: unclickable ? "inherit" : "pointer",
  gridTemplateColumns: icon ? (iconPosition === "left" ? "1fr 3fr " : "3fr 1fr") : "unset",
  pointerEvents: disabled ? "none" : "initial",
  outline: "none",
  opacity: disabled ? 0.65 : "initial",
  transition: `background-color ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeOut}`,
  ...(!unclickable
    ? {
        "&:hover, &:active, &:focus-visible": {
          color: active ? theme.palette.card.contrastText : theme.palette.card.dark,
          stroke: !iconUsesStroke ? "none" : active ? theme.palette.white.main : theme.palette.primary.main,
          fill: iconUsesStroke ? "red" : active ? theme.palette.white.main : theme.palette.card.dark,
          transition: `background-color ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeOut}`,
          background: active ? theme.palette.card.dark : theme.palette.card.light,
        },
      }
    : {}),
}));
